import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    Tooltip,
    Filler
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    Tooltip,
    Filler
);

export default function Chart({ chart }) {
    if (!chart) return null;

    const data = {
        labels: chart.dates,
        datasets: [
            {
                label: "Price",
                data: chart.prices,
                borderColor: "#3b82f6",
                backgroundColor: "rgba(37, 99, 235, 0.13)",
                fill: true,
                borderWidth: 2.5,
                tension: 0.1,
            },
            {
                label: "50-day MA",
                data: chart.ma50,
                borderColor: "#f59e0b",
                backgroundColor: "rgba(245, 158, 11, 0.8)",     // to match legend
                borderWidth: 2,
                borderDash: [4, 4],
                tension: 0.1,
            },
            {
                label: "200-day MA",
                data: chart.ma200,
                borderColor: "#9ca3af",
                backgroundColor: "rgba(156, 163, 175, 0.6)",    // to match legend
                borderWidth: 2,
                borderDash: [8, 6],
                tension: 0.1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: { position: "top" },
            tooltip: {
                mode: "index",
                intersect: false,
            },
        },
        interaction: {
            mode: "index",
            intersect: false,
        },
        elements: {
            point: { radius: 0 },
        },
    };

    return (
        <div style={{ marginTop: "30px" }}>
            <h3>Chart</h3>
            <Line data={data} options={options} />
        </div>
    );
}